import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { fetchTaskStatus } from '../automationResultService.js';
import './TaskStatusTracker.css'; // 引入CSS文件
import { AUTOMATION_TASKS_TYPES } from '@/constants/constants.js';

export const TaskStatusTracker = () => {
  const { client_id } = useParams();
  const [taskStatus, setTaskStatus] = useState([]);

  useEffect(() => {
    const fetchStatus = async () => {
      const taskStatus = await fetchTaskStatus(client_id);
      setTaskStatus(taskStatus);
    };
    fetchStatus();
  }, [client_id]);

  const renderStatus = (status) => {
    switch (status) {
      case AUTOMATION_TASKS_TYPES.正在执行:
        return (
          <>
            正在执行 <span className="loading-icon">🔄</span>
          </>
        );
      case AUTOMATION_TASKS_TYPES.全部成功:
        return (
          <>
            全部成功 <span className="success-icon">✔️</span>
          </>
        );
      case AUTOMATION_TASKS_TYPES.部分成功:
        return (
          <>
            部分成功 <span className="partial-success-icon">⚠️</span>
          </>
        );
      case AUTOMATION_TASKS_TYPES.失败:
        return (
          <>
            失败 <span className="failure-icon">❌</span>
          </>
        );
      default:
        return '未执行';
    }
  };

  return (
    <div className="result-status-container">
      <h1>任务状态追踪</h1>
      <table className="status-table">
        <thead>
          <tr>
            <th>Batch ID</th>
            <th>Image Task</th>
            <th>Oration Audio Task</th>
            <th>Farewell Audio Task</th>
            <th>Digital Human Task</th>
            {/* <th>Create Time</th>
            <th>Update Time</th>
            <th>Started By</th> */}
          </tr>
        </thead>
        <tbody>
          {taskStatus &&
            taskStatus.length > 0 &&
            taskStatus.map((status) => (
              <tr key={status.id}>
                <td>{status.id}</td>
                <td>{renderStatus(status.image_task)}</td>
                <td>{renderStatus(status.oration_audio_task)}</td>
                <td>{renderStatus(status.farewell_audio_task)}</td>
                <td>{renderStatus(status.digitalHuman_task)}</td>
                {/* <td>{status.create_time}</td>
                <td>{status.update_time}</td>
                <td>{status.started_by}</td> */}
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default TaskStatusTracker;
